import { ModeToggle } from './ModeToggle';
import { UserMenu } from '../UserMenu';
import { SettingsMenu } from '../settings/SettingsMenu';
import '../../styles/header-layout.css';

/**
 * TopBar - Reorganized therapist panel header
 *
 * Layout:
 * - Row 1: [User Info/Sign In] | [Settings]
 * - Row 2: [Advanced/Simple Toggle - Full Width Pill Style]
 *
 * Features:
 * - Clean two-row design optimized for vertical space
 * - Pill-style segmented control for mode toggle
 * - Settings access via gear icon
 */

export function TopBar(): JSX.Element {
  return (
    <div className="therapist-header">
      {/* Top Row: User Info (left) | Settings (right) */}
      <div className="therapist-header-top">
        <div className="therapist-header-left">
          <UserMenu />
        </div>

        <div className="therapist-header-right">
          <SettingsMenu />
        </div>
      </div>

      {/* Second Row: UI Mode Toggle (full width pill-style) */}
      <div className="ui-mode-toggle-container">
        <ModeToggle />
      </div>
    </div>
  );
}
